import { render } from "./web-login.vue?vue&type=template&id=ba52a648&scoped=true"
import script from "./web-login.vue?vue&type=script&lang=js"
export * from "./web-login.vue?vue&type=script&lang=js"

import "./web-login.vue?vue&type=style&index=0&id=ba52a648&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba52a648"]])

export default __exports__